import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";
import ManagerProtectedRoute from "./components/ManagerProtectedRoute";
import BackendHealthGate from "./components/BackendHealthGate";
import PageTitle from "./components/PageTitle";
import NotFound from "./pages/NotFound";
import { EmployeeSelfServicePage } from '@restaurant-manager/frontend/employee-management';
import ManagerSelfService from './pages/manager-self-service';
import LoginPage from './pages/login';
import { EmployeeOnboardingPage } from '@restaurant-manager/frontend/employee-management';
import { InternalMessagingPage } from '@restaurant-manager/frontend/internal-messaging';
import { EmployeeDirectoryPage } from '@restaurant-manager/frontend/employee-management';
import { TimeOffManagementPage } from '@restaurant-manager/frontend/absence-management';
import { EmployeeSchedulingPage } from '@restaurant-manager/frontend/shift-management';
import EmployeeReview from '@restaurant-manager/frontend/employee-management/employee-directory/EmployeeReview';
import DashboardLanding from './pages/DashboardLanding';
import { IncidentReportsPage } from '@restaurant-manager/frontend/incident-reporting';
import { HiringProcessPage, PublicJobApplicationPage } from '@restaurant-manager/frontend/hiring-process';
import SettingsPage from './pages/settings';
import { SupportPage as SupportFeaturePage } from '@restaurant-manager/frontend/support-system';
import { AuthProvider } from "./context/AuthContext";
import { LocationsProvider } from "./context/LocationsContext";
import { BusinessesProvider } from "./context/BusinessesContext";
import { LanguageProvider } from "./context/LanguageContext";
import PasswordResetPage from './pages/password-reset';
import { TrainingsPage } from '@restaurant-manager/frontend/in-job-training';
import TrainingDetailPage from '@restaurant-manager/frontend/in-job-training/trainings/TrainingDetail';

const Routes = () => {
  return (
    <BackendHealthGate>
      <AuthProvider>
        <LanguageProvider>
          <BusinessesProvider>
            <LocationsProvider>
              <BrowserRouter>
                <PageTitle />
                <ErrorBoundary>
                  <ScrollToTop />
                  <RouterRoutes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/forgot-password" element={<PasswordResetPage />} />
                <Route
                  path="/"
                  element={(
                    <ProtectedRoute>
                      <DashboardLanding />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/employee-self-service"
                  element={(
                    <ProtectedRoute>
                      <EmployeeSelfServicePage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/manager-self-service"
                  element={(
                    <ProtectedRoute>
                      <ManagerSelfService />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/internal-messaging"
                  element={(
                    <ProtectedRoute>
                      <InternalMessagingPage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/employee-directory"
                  element={(
                    <ProtectedRoute>
                      <EmployeeDirectoryPage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/employee-directory/:employeeId"
                  element={(
                    <ManagerProtectedRoute>
                      <EmployeeReview />
                    </ManagerProtectedRoute>
                  )}
                />
                <Route
                  path="/time-off-management"
                  element={(
                    <ProtectedRoute>
                      <TimeOffManagementPage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/employee-scheduling"
                  element={(
                    <ProtectedRoute>
                      <EmployeeSchedulingPage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/incident-reports"
                  element={(
                    <ProtectedRoute>
                      <IncidentReportsPage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/hiring"
                  element={(
                    <ManagerProtectedRoute>
                      <HiringProcessPage />
                    </ManagerProtectedRoute>
                  )}
                />
                <Route
                  path="/support"
                  element={(
                    <ManagerProtectedRoute>
                      <SupportFeaturePage />
                    </ManagerProtectedRoute>
                  )}
                />
                <Route
                  path="/trainings"
                  element={(
                    <ProtectedRoute>
                      <TrainingsPage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/trainings/:trainingId"
                  element={(
                    <ProtectedRoute>
                      <TrainingDetailPage />
                    </ProtectedRoute>
                  )}
                />
                <Route
                  path="/settings"
                  element={(
                    <ProtectedRoute>
                      <SettingsPage />
                    </ProtectedRoute>
                  )}
                />
                <Route path="/onboarding" element={<EmployeeOnboardingPage />} />
                <Route path="/public/hiring/apply" element={<PublicJobApplicationPage />} />
                <Route path="*" element={<NotFound />} />
                  </RouterRoutes>
                </ErrorBoundary>
              </BrowserRouter>
            </LocationsProvider>
          </BusinessesProvider>
        </LanguageProvider>
      </AuthProvider>
    </BackendHealthGate>
  );
};

export default Routes;
